/**
 * Portal route shell.
 *
 * Routes:
 *   `/` and `/onboarding`  → the onboarding wizard (chrome-free, reads
 *                            `?invite=<token>` to drive its state).
 *                            Existing invitation emails point at
 *                            `app.finn.a7on.ai/?invite=…` and continue
 *                            to work unchanged.
 *   `/account`             → the authenticated Account page, wrapped in
 *                            the persistent-sidebar layout.
 *   `/knowledge`           → the RAG knowledge management page (Phase 3
 *                            of the RAG knowledge initiative). Same
 *                            authenticated layout; route gate (only
 *                            onboarding admins) lives inside the page.
 */
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AuthenticatedLayout } from "@/components/AuthenticatedLayout";
import { AccountPage } from "@/pages/AccountPage";
import { KnowledgePage } from "@/pages/KnowledgePage";
import { MCPServersPage } from "@/pages/MCPServersPage";
import { Wizard } from "@/pages/Wizard";

export function App({ authConfigured }: { authConfigured: boolean }) {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Wizard authConfigured={authConfigured} />} />
        <Route
          path="/onboarding"
          element={<Wizard authConfigured={authConfigured} />}
        />
        <Route
          path="/account"
          element={
            <AuthenticatedLayout authConfigured={authConfigured}>
              <AccountPage authConfigured={authConfigured} />
            </AuthenticatedLayout>
          }
        />
        <Route
          path="/knowledge"
          element={
            <AuthenticatedLayout authConfigured={authConfigured}>
              <KnowledgePage authConfigured={authConfigured} />
            </AuthenticatedLayout>
          }
        />
        <Route
          path="/mcp"
          element={
            <AuthenticatedLayout authConfigured={authConfigured}>
              <MCPServersPage authConfigured={authConfigured} />
            </AuthenticatedLayout>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
